import { categoryToProduct, getShopBannerConfig } from './data';
import type { ShopCategoryId } from './data';
export type { ShopCategoryId } from './data';

export const isShopCategory = (
  categoryId: number,
): categoryId is ShopCategoryId => {
  return Object.prototype.hasOwnProperty.call(categoryToProduct, categoryId);
};

export { getShopBannerConfig };
